import React, { useState, useEffect } from 'react';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from '../ui/command';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';
import { Button } from '../ui/button';
import { Check, ChevronsUpDown } from 'lucide-react';
import { cn } from '../../lib/utils';

const defaultSubjects = [
  "Introduction to Programming",
  "Web Development Basics",
  "Advanced JavaScript",
  "React Fundamentals",
  "Database Design",
  "API Development",
  "UI/UX Design",
  "Mobile App Development",
  "Cloud Computing",
  "Software Testing"
];

interface SubjectSearchDropdownProps {
  value: string;
  allsubjects:any;
  onChange: (value: string) => void;
  placeholder?: string;
}

const SubjectSearchDropdown = ({ 
  value, 
  allsubjects,
  onChange, 
  placeholder = "Select a subject..." 
}: any) => {
  const [open, setOpen] = useState(false);
  const [inputValue, setInputValue] = useState("");
  
  // Reset input value when popup opens/closes
  useEffect(() => {
    if (open) {
      setInputValue(value); // Set to current value when opening
    } else {
      setInputValue(""); // Reset when closing
    }
    console.log(allsubjects)
  }, [open, value]);

  const handleInputChange = (value: string) => {
    setInputValue(value);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' && inputValue.trim() && !allsubjects.some(subject => 
      subject?.subjectName?.toLowerCase() === inputValue.toLowerCase()
    )) {
      onChange(inputValue.trim());
      setOpen(false);
    }
  };

  const handleSelect = (currentValue: string) => {
    onChange(currentValue === value ? "" : currentValue);
    setOpen(false);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className="w-full justify-between"
        >
          {value || placeholder}
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-full p-0">
        <Command shouldFilter={false} onKeyDown={handleKeyDown}>
          <CommandInput 
            placeholder="Search or type a new subject..." 
            value={inputValue}
            onValueChange={handleInputChange}
          />
          <CommandList>
            {inputValue && !allsubjects?.some(subject => 
              subject?.subjectName?.toLowerCase() === inputValue.toLowerCase()
            ) && (
              <CommandEmpty className="py-3 text-sm italic">
                Press enter to add "{inputValue}" as a new subject
              </CommandEmpty>
            )}
            <CommandGroup heading="Available Subjects">
              {allsubjects
                ?.filter(subject => 
                  subject?.subjectName?.toLowerCase().includes(inputValue?.toLowerCase())
                )
                .map((subject) => (
                  <CommandItem
                    key={subject?.subjectName}
                    value={subject?.subjectName}
                    onSelect={handleSelect}
                  >
                    <Check
                      className={cn(
                        "mr-2 h-4 w-4",
                        value === subject ? "opacity-100" : "opacity-0"
                      )}
                    />
                    {subject?.subjectName}
                  </CommandItem>
                ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};

export default SubjectSearchDropdown;